/* Tempo Kicks - extra color swatch groups (round bubbles linking sibling colorway products).
   Loaded after tempo-swatches.js. Add new families here: one array per model,
   one [handle, image-file] per colorway (file name in Content > Files, prefix added automatically). */
(function () {
  'use strict';
  var IMG = 'https://cdn.shopify.com/s/files/1/0949/1526/4778/files/';
  var GROUPS = [
    [["new-balance-abzorb-2000-baby-blue","u2000pbb_nb_02_i.jpg"],["new-balance-abzorb-2000-black","u2000etb_nb_02_i.jpg"],["new-balance-abzorb-2000-slate-grey","u20006ou_nb_02_i.jpg"],["new-balance-abzorb-2000-sea-salt","u20007ys_nb_02_i.jpg"],["new-balance-abzorb-2000-rain-cloud-pink","u200035p_nb_02_i.jpg"],["new-balance-abzorb-2000-silver-metallic-faded-black","u20003oz_nb_02_i.jpg"]],
    [["new-balance-1000-silver-metallic","m1000sl_nb_02_i.jpg"],["new-balance-1000-angora-moonrock","m1000wa_nb_02_i.jpg"],["new-balance-1000-black","m1000db_nb_02_i.jpg"],["new-balance-1000-slate-grey","m1000a_nb_02_i.jpg"],["new-balance-1000-cordura-black-silver-metallic","m1000egr_nb_02_i.jpg"]]
  ];
  // ---- Bubble border = dominant colour of the sneaker + auto-centering of the shoe inside the bubble
  //      (both computed from the thumbnail, works for every family, even portrait photos) ----
  var colorCache = {};
  function dominantColor(url, cb) {
    if (colorCache[url]) return cb(colorCache[url]);
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        // 1) bounding box of the shoe (non-white pixels) on the real thumbnail, to center it in the bubble
        var W = img.naturalWidth || 120, IH = img.naturalHeight || 120;
        var cb2 = document.createElement('canvas'); cb2.width = W; cb2.height = IH;
        var ctx2 = cb2.getContext('2d'); ctx2.drawImage(img, 0, 0, W, IH);
        var dd = ctx2.getImageData(0, 0, W, IH).data;
        var minx = W, miny = IH, maxx = -1, maxy = -1;
        for (var yy = 0; yy < IH; yy++) {
          for (var xx = 0; xx < W; xx++) {
            var q = (yy * W + xx) * 4;
            if (dd[q + 3] < 128) continue;
            if (dd[q] > 238 && dd[q + 1] > 238 && dd[q + 2] > 238) continue;
            if (xx < minx) minx = xx; if (xx > maxx) maxx = xx; if (yy < miny) miny = yy; if (yy > maxy) maxy = yy;
          }
        }
        var box = null;
        if (maxx > minx + 4 && maxy > miny + 4) {
          box = { cx: (minx + maxx) / 2 / W, cy: (miny + maxy) / 2 / IH, fw: (maxx - minx + 1) / W, fh: (maxy - miny + 1) / IH, ar: W / IH };
        }
        // 2) dominant colour on a small 48x48 sample
        var c = document.createElement('canvas'); c.width = 48; c.height = 48;
        var ctx = c.getContext('2d'); ctx.drawImage(img, 0, 0, 48, 48);
        var d = ctx.getImageData(0, 0, 48, 48).data;
        var r = 0, g = 0, b = 0, n = 0, rs = 0, gs = 0, bs = 0, ns = 0;
        for (var i = 0; i < d.length; i += 4) {
          var R = d[i], G = d[i + 1], B = d[i + 2], A = d[i + 3];
          if (A < 128) continue;
          if (R > 232 && G > 232 && B > 232) continue; // white background
          var max = Math.max(R, G, B), min = Math.min(R, G, B), sat = max ? (max - min) / max : 0;
          r += R; g += G; b += B; n++;
          if (sat > 0.28 && max > 60) { rs += R; gs += G; bs += B; ns++; } // saturated pixels = the shoe's real colour
        }
        var col;
        if (ns >= 12) col = [rs / ns, gs / ns, bs / ns];
        else if (n) col = [r / n, g / n, b / n];
        else col = [160, 160, 160];
        // boost saturation a little and keep the ring readable on white (HSL: S x1.35, L between 0.32 and 0.58)
        var R1 = col[0] / 255, G1 = col[1] / 255, B1 = col[2] / 255;
        var mx = Math.max(R1, G1, B1), mn = Math.min(R1, G1, B1), L = (mx + mn) / 2, H = 0, S = 0;
        if (mx !== mn) {
          var dlt = mx - mn;
          S = L > 0.5 ? dlt / (2 - mx - mn) : dlt / (mx + mn);
          if (mx === R1) H = ((G1 - B1) / dlt + (G1 < B1 ? 6 : 0)) / 6;
          else if (mx === G1) H = ((B1 - R1) / dlt + 2) / 6;
          else H = ((R1 - G1) / dlt + 4) / 6;
        }
        if (S > 0.08) S = Math.min(1, S * 1.35);
        L = Math.min(0.58, Math.max(0.32, L));
        var out = { col: 'hsl(' + Math.round(H * 360) + ',' + Math.round(S * 100) + '%,' + Math.round(L * 100) + '%)', box: box };
        colorCache[url] = out; cb(out);
      } catch (e) { /* canvas tainted or unavailable: keep default border */ }
    };
    img.src = url;
  }
  function paintAll() {
    document.querySelectorAll('.tempo-swatches a').forEach(function (a) {
      if (a.getAttribute('data-tempo-painted')) return;
      a.setAttribute('data-tempo-painted', '1');
      var bg = a.style.backgroundImage || '';
      var mm = bg.match(/url\(["']?([^"')]+)["']?\)/);
      if (!mm) return;
      dominantColor(mm[1], function (res) {
        var col = typeof res === 'string' ? res : res.col;
        var box = typeof res === 'string' ? null : res.box;
        var current = a.classList.contains('tempo-swatch-current');
        a.style.border = (current ? '3px' : '2px') + ' solid ' + col;
        a.style.opacity = current ? '1' : '0.92';
        if (box) {
          // scale so the shoe fills ~78% of the bubble, then shift the background so the shoe's center = bubble center
          var size = a.clientWidth || 64;
          var target = size * 0.78;
          var bgW = Math.min(target / box.fw, (target / box.fh) * box.ar);
          var bgH = bgW / box.ar;
          a.style.backgroundSize = bgW.toFixed(1) + 'px ' + bgH.toFixed(1) + 'px';
          a.style.backgroundPosition = (size / 2 - box.cx * bgW).toFixed(1) + 'px ' + (size / 2 - box.cy * bgH).toFixed(1) + 'px';
        }
      });
    });
  }

  var m = location.pathname.match(/\/products\/([a-z0-9-]+)/);
  if (!m) return;
  var handle = m[1];
  var group = null;
  for (var i = 0; i < GROUPS.length && !group; i++) {
    for (var j = 0; j < GROUPS[i].length; j++) {
      if (GROUPS[i][j][0] === handle) { group = GROUPS[i]; break; }
    }
  }
  var hasGroup = !!(group && group.length >= 2);
  function titleOf(h) {
    return h.split('-').map(function (w) { return w ? w.charAt(0).toUpperCase() + w.slice(1) : w; }).join(' ');
  }
  function build() {
    if (!hasGroup) return true;
    if (document.querySelector('.tempo-swatches')) return true;
    var anchor = document.querySelector('.product-form-input[data-option-name]') ||
                 document.querySelector('.product-form-input-dropdown') ||
                 document.querySelector('variant-selects, .product-form__input');
    if (!anchor) return false;
    var row = document.createElement('div');
    row.className = 'tempo-swatches';
    row.style.cssText = 'display:flex;flex-wrap:nowrap;overflow-x:auto;-webkit-overflow-scrolling:touch;gap:10px;margin:16px 0 6px;padding:2px 2px 8px 2px;scrollbar-width:thin;';
    group.forEach(function (p) {
      var a = document.createElement('a');
      a.style.cssText = 'display:block;flex:0 0 auto;width:64px;height:64px;border-radius:50%;border:1px solid #d9d9d9;background-color:#f6f6f6;background-size:80%;background-position:center;background-repeat:no-repeat;';
      a.href = '/products/' + p[0];
      a.title = titleOf(p[0]);
      a.setAttribute('aria-label', a.title);
      a.style.backgroundImage = 'url("' + IMG + p[1] + '?width=120")';
      if (p[0] === handle) { a.className = 'tempo-swatch-current'; a.style.border = '2px solid #1b1b1b'; a.style.pointerEvents = 'none'; }
      row.appendChild(a);
    });
    anchor.parentNode.insertBefore(row, anchor.nextSibling);
    var cur = row.querySelector('.tempo-swatch-current');
    if (cur) { row.scrollLeft = Math.max(0, cur.offsetLeft - row.clientWidth / 2 + 32); }
    return true;
  }
  build();
  // keep watching: the theme re-renders the product form on variant change, which removes the row
  var mo = new MutationObserver(function () { build(); paintAll(); });
  mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', function () { build(); paintAll(); });
  paintAll();
})();
